'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ', 'rem;\n  margin-left: ', 'rem;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ', 'rem;\n  margin-left: ', 'rem;\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    justify-content: flex-start;\n    text-align: start;\n  '], ['\n    justify-content: flex-start;\n    text-align: start;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    justify-content: center;\n    text-align: center;\n  '], ['\n    justify-content: center;\n    text-align: center;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    justify-content: flex-end;\n    text-align: end;\n  '], ['\n    justify-content: flex-end;\n    text-align: end;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    align-items: flex-start;\n  '], ['\n    align-items: flex-start;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    align-items: center;\n  '], ['\n    align-items: center;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    align-items: flex-end;\n  '], ['\n    align-items: flex-end;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    justify-content: space-around;\n  '], ['\n    justify-content: space-around;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    justify-content: space-between;\n  '], ['\n    justify-content: space-between;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    order: -1;\n  '], ['\n    order: -1;\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    order: 1;\n  '], ['\n    order: 1;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _createProps = require('../createProps');

var _createProps2 = _interopRequireDefault(_createProps);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModificatorType = _propTypes2.default.oneOf(_config.DIMENSION_NAMES);

var Row = function Row(props) {
  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(Row.propTypes, props));
};

Row.displayName = 'Row';

Row.propTypes = {
  reverse: _propTypes2.default.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType,
  first: ModificatorType,
  last: ModificatorType,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = (0, _styledComponents2.default)(Row)(_templateObject, function (p) {
  return (0, _config2.default)(p).gutterWidth / 2 * -1;
}, function (p) {
  return (0, _config2.default)(p).gutterWidth / 2 * -1;
}, function (p) {
  return p.reverse && '\n    flex-direction: row-reverse;\n  ';
}, function (p) {
  return p.start && (0, _config2.default)(p).media[p.start](_templateObject2);
}, function (p) {
  return p.center && (0, _config2.default)(p).media[p.center](_templateObject3);
}, function (p) {
  return p.end && (0, _config2.default)(p).media[p.end](_templateObject4);
}, function (p) {
  return p.top && (0, _config2.default)(p).media[p.top](_templateObject5);
}, function (p) {
  return p.middle && (0, _config2.default)(p).media[p.middle](_templateObject6);
}, function (p) {
  return p.bottom && (0, _config2.default)(p).media[p.bottom](_templateObject7);
}, function (p) {
  return p.around && (0, _config2.default)(p).media[p.around](_templateObject8);
}, function (p) {
  return p.between && (0, _config2.default)(p).media[p.between](_templateObject9);
}, function (p) {
  return p.first && (0, _config2.default)(p).media[p.first](_templateObject10);
}, function (p) {
  return p.last && (0, _config2.default)(p).media[p.last](_templateObject11);
});


//////////////////
// WEBPACK FOOTER
// ./~/react-styled-flexboxgrid/lib/components/Row.js
// module id = 346
// module chunks = 0